// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XXnT","questions":"styles_questions__1CmfI","footer":"styles_footer__2Czsi"};